export const validateMap = {
    "starttime": {
        required: true,
        type: "string",
        min: 4,
    },
}